// import { find, replace, split, length, filter, startsWith } from "ramda";
// import { appLocales } from "application/constants/app-constants";

export default function getLangToSend() {
  const lang = navigator.language || navigator.userLanguage;
  let parseLang =
    lang && lang !== "" && lang.includes("-") ? lang.replace("-", "_") : lang;
  if (parseLang === "DA" || parseLang === "da") {
    parseLang = "da_DK";
  } else  if (parseLang === "it" || parseLang === "IT") {
    parseLang = "it_IT";
  } else  if (parseLang === "es" || parseLang === "ES") {
    parseLang = "es_ES";
  } else  if (parseLang === "de" || parseLang === "DE") {
    parseLang = "de_DE";
  } else  if (parseLang === "nl" || parseLang === "NL") {
    parseLang = "nl_NL";
  } else  if (parseLang === "fr" || parseLang === "FR") {
    parseLang = "fr_FR";
  } else  if (parseLang === "pt" || parseLang === "PT") {
    parseLang = "pt_PT";
  } else  if (parseLang === "sr" || parseLang === "SR") {
    parseLang = "sr_RS";
  } else  if (parseLang === "en" || parseLang === "EN") {
    parseLang = "en_US";
  }
  return parseLang !== "" ? parseLang : "en_US";
}
